<template>
  <div class="container-fluid row">
    <div class="mt-5 col-md-12">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 mt-3">
            <h5 class="card-title">สร้างข้อมูลการคุมสอบ</h5>
          </div>
          <div class="col-md-3 mt-3">
            <label for="exampleFormControlSelect1">ปีการศึกษา</label>
            <select v-model="filter.year" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in year" v-bind:value="s.id" :key="i + 1">
                {{ s.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3">
            <label for="exampleFormControlSelect1">เทอม</label>
            <select v-model="filter.term" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in term" v-bind:value="s.id" :key="i + 1">
                {{ s.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-5">
            <label for="exampleFormControlSelect1">ประเภทการสอบ</label>
            <select v-model="filter.exam_type" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in exam_type" v-bind:value="s.name" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-5">
            <button @click="save()" type="button" class="btn btn-success btn-sm">
              สร้างข้อมูลการคุมสอบ
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 ">
            <h5 class="card-title">ค้นหา</h5>
          </div>
          <div class="col-md-3 mt-3">
            <label for="exampleFormControlSelect1">ปีการศึกษา</label>
            <select v-model="search_data.year" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in year_examiner" v-bind:value="s.id" :key="i + 1">
                {{ s.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3">
            <label for="exampleFormControlSelect1">เทอม</label>
            <select v-model="search_data.term" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in term_examiner" v-bind:value="s.id" :key="i + 1">
                {{ s.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">ประเภทการสอบ</label>
            <select v-model="search_data.exam_type" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in exam_type_examiner" v-bind:value="s.name" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">รายวิชา</label>
            <select v-model="search_data.subject" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in major" v-bind:value="s.id" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">เลือกวันที่สอบ</label>
            <input type="date" id="examDate" class="form-control form-control-sm" v-model="search_data.exam_date"
              @change="formatDateFilter" />
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">อาจารย์ผู้สอน</label>
            <input type="text" id="examDate" class="form-control form-control-sm" v-model="search_data.instructor" />
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">คณะ</label>
            <select v-model="search_data.faculty_id" class="form-select form-control-sm" id="exampleFormControlSelect1"
              @change="getCoursesByFaculty">
              <option v-for="(s, i) in faculty" v-bind:value="s.id" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <!-- <label for="exampleFormControlSelect1">หลักสูตร</label>
            <select v-model="search_data.course_id" class="form-select form-control-sm" id="exampleFormControlSelect1"
              @change="getFacultyByCourses">
              <option v-for="(s, i) in courselist" v-bind:value="s.id" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select> -->
          </div>
          <div class="col-md-3">
            <button @click="search()" type="button" class="btn btn-primary btn-sm">
              ค้นหา
            </button>&nbsp;
            <button @click="clear()" type="button" class="btn btn-danger btn-sm">
              ล้างค่าการค้นหา
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 mt-5" style="margin: 5px" v-if="list_data.length > 0">
      <div v-for="(group, index) in list_data" :key="index" class="mb-4 border rounded">
        <div class="p-2 bg-secondary text-white d-flex justify-content-between align-items-center"
          style="cursor: pointer;">
          <strong>ปี {{ group.term }}/{{ group.year }}
            ({{ group.exam_type === 'M' ? 'Midterm' : group.exam_type === 'F' ? 'Final' : '' }})
          </strong>
          <span @click="toggleShow(index)">{{ group.show ? '▲ ซ่อน' : '▼ แสดง' }}</span>
          <!-- PDF Button -->
          <div class="pdf-button">
            <!-- PDF Icon SVG -->
            <a :href="link + group.pdf_file" target="_blank" rel="noopener" class="pdf-button" style="color: white;">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                class="pdf-icon">
                <path fill="#E53935" d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
                <path fill="#fff" d="M13 3v6h6" />
                <text x="6.5" y="17" fill="#fff" font-size="8" font-weight="bold" font-family="Arial, sans-serif">
                  PDF
                </text>
              </svg>
              <span class="label">ดาวน์โหลด PDF</span>
            </a>
            <!-- &nbsp;&nbsp;
            <button @click="generate(group)" type="button" class="btn btn-info btn-sm">
              create
            </button> -->
          </div>
        </div>

        <!-- <div class="collapse" id="collapseExample"> -->
        <div class="table-responsive" v-show="group.show">
          <table class="table table-bordered mt-2">
            <thead>
              <tr style="text-align: center">
                <th scope="col" style="background-color: #C4996C">ลำดับที่</th>
                <th scope="col" style="background-color: #C4996C">วันที่</th>
                <th scope="col" style="background-color: #C4996C">เวลา</th>
                <th scope="col" style="background-color: #C4996C">รายวิชา</th>
                <th scope="col" style="background-color: #C4996C">กลุ่ม(จำนวน)</th>
                <th scope="col" style="background-color: #C4996C">ห้อง</th>
                <th scope="col" style="background-color: #C4996C">กรรมการคุมสอบ</th>
                <th scope="col" style="background-color: #C4996C">สังกัด</th>
                <th scope="col" style="background-color: #C4996C">เบอร์ติดต่อคณะ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, i) in group.detail" :key="i + 1">
                <th scope="row" style="text-align: center;width: 2%;">{{ i + 1 }}</th>
                <td style="text-align: center;width: 8%;">{{ formatDate(s.exam_date) }}</td>
                <td style="text-align: center;width: 8%;">
                  {{ trimSecondsFromTimeRange(s.exam_time_from) }} - {{ trimSecondsFromTimeRange(s.exam_time_to) }}
                </td>
                <td style="text-align: left;width: 20%;">{{ s.code }}: {{ s.major_name }} ({{ s.number }})</td>
                <td style="text-align: left;width: 10%;">{{ s.group_m }} ({{ s.number }})</td>
                <td style="text-align: center;width: 10%;">{{ s.room_name }}</td>
                <td style="text-align: left;width: 20%;">
                  <span v-for="(p, ii) in s.proctor" :key="ii">
                    {{ ii + 1 }}: {{ p.fullname }} <i class="fas fa-edit ms-2 text-primary" style="cursor: pointer;"
                      @click="editInstructor(p)" data-bs-toggle="modal" data-bs-target="#EditInstructor"></i>
                    <br>
                  </span>

                </td>
                <td style="text-align: left;width: 15%;">
                  <span v-for="(p, ii) in s.proctor" :key="ii">
                    {{ p.faculty_name }}
                    <br>
                  </span>
                </td>
                <td style="text-align: left;width: 12%;">
                  <span v-for="(p, ii) in s.proctor" :key="ii">
                    {{ p.tel }}
                    <br>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


    <!-- Modal -->
    <div class="modal fade" id="EditInstructor" tabindex="-1" aria-labelledby="EditInstructorLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="EditInstructorLabel">แก้ไขข้อมูลกรรมการคุมสอบ</h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="ปิด"></button>
          </div>
          <div class="modal-body">
            <div class="form-group mt-3">
              <label for="exampleFormControlSelect1">กรรมการคุมสอบ</label>
              <select v-model="second_proctor.new_second_proctor_id" class="form-select form-control-sm"
                id="exampleFormControlSelect1">
                <option v-for="(p, i) in proctor" v-bind:value="p.id" :key="i + 1">
                  {{ p.fullname }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="username">remark</label>
              <input v-model="second_proctor.remark" type="text" min="1" class="form-control form-control-sm"
                id="username" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="closed">ปิด</button>
            <button type="button" class="btn btn-primary" @click="saveInstructor()">บันทึก</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import axios from 'axios';
import LinkService from "../services/LinkService";
import CourseService from "../services/CourseService";
import ProctorService from "../services/ProctorService";
import MajorService from "../services/MajorService";
import AcademicPositionService from "../services/AcademicPositionService";
import FacultyService from "../services/FacultyService";
import ExamRemarkService from "../services/ExamRemarkService";
import ExaminationScheduleService from "../services/ExaminationScheduleService";
import ExaminerRemarkService from "../services/ExaminerRemarkService";
import ExaminerService from "../services/ExaminerService";

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  data() {
    return {
      course: [],
      proctor: [],
      major: [],
      subjects: [],
      academic_positions: [],
      year: [],
      term: [],
      exam_type: [],
      year_examiner: [],
      term_examiner: [],
      exam_type_examiner: [],
      filter: { year: '', term: '', exam_type: '' },
      search_data: { year: '', term: '', exam_type: '', exam_date: '', faculty_id: '', course_id: '', subject: '', instructor: '' },
      subjectdisplay: [],
      AssignsDisplay: [],
      link: LinkService.getLink(),
      title: '',
      second_proctor: {},
      second_proctor_id: '',
      faculty: [],
      second_proctor_list: [],
      list_data: [],
      ExaminationScheduleAllList:[]
    };
  },
  mounted() {
    // let maxS = Math.ceil((2 * 25) / 15);
    // console.log(maxS);

    this.getCourses()
    this.getMajors();
    this.getFaculty()
    // this.getSubjects()

    // this.getAcademicPosition()
    this.getExaminationScheduleAll()
    // console.log(this.AssignsDisplay);
    this.getAll()

  },
  methods: {
    getAll() {
      ExaminationScheduleService.getAll({ year: '', term: '', exam_type: '', exam_date: '', faculty_id: '', course_id: '', subject: '', instructor: '' }).then((res) => {
        console.log(res.data);
        this.ExaminationScheduleAllList = res.data
        this.year = [...new Set(this.ExaminationScheduleAllList.map(item => item.year))] // unique years
          .sort((a, b) => b - a) // sort descending if needed
          .map(y => ({ id: y, name: y }));
        this.term = [...new Set(this.ExaminationScheduleAllList.map(item => item.term))] // unique years
          .sort((a, b) => b - a) // sort descending if needed
          .map(y => ({ id: y, name: y }));

        const examTypeMap = {
          M: { id: 1, nameTH: "Midterm", name: "M" },
          F: { id: 2, nameTH: "Final", name: "F" }
        }
        this.exam_type = [...new Set(this.ExaminationScheduleAllList.map(item => item.exam_type))]
          .map(code => examTypeMap[code])
          .filter(Boolean)
          // console.log(this.filter,'filter');
          
      });
    },
    getExaminationScheduleAll() {
      ExaminationScheduleService.getExaminationScheduleAll(this.search_data).then((res) => {
        this.list_data = res.data;
        console.log(this.list_data, 'getExaminationScheduleAll');
        this.list_data.forEach(group => {
          this.$set(group, 'show', false); // ใช้ Vue.set หรือ this.$set
        });
        
        this.year_examiner = [...new Set(this.list_data.map(item => item.year))] // unique years
          .sort((a, b) => b - a) // sort descending if needed
          .map(y => ({ id: y, name: y }));
        this.term_examiner = [...new Set(this.list_data.map(item => item.term))] // unique years
          .sort((a, b) => b - a) // sort descending if needed
          .map(y => ({ id: y, name: y }));

        const examTypeMap = {
          M: { id: 1, nameTH: "Midterm", name: "M" },
          F: { id: 2, nameTH: "Final", name: "F" }
        }
        this.exam_type_examiner = [...new Set(this.list_data.map(item => item.exam_type))]
          .map(code => examTypeMap[code])
          .filter(Boolean)
          // console.log(this.filter,'filter');
    });
    },
    toggleShow(index) {
      this.list_data[index].show = !this.list_data[index].show;
    },
    getFaculty() {
      FacultyService.getFacultys().then((res) => {
        this.faculty = res.data;
        // console.log(this.faculty);
      });
    },
    getFacultyByCourses() {
      const facultylist = this.course.find(c =>
        c.id === this.search_data.course_id
      );
      this.search_data.faculty_id = facultylist.faculty_id;
    },
    getCoursesByFaculty() {
      const courselist = this.course.filter(c =>
        c.faculty_id === this.search_data.faculty_id
      );
      this.courselist = courselist;
    },
    formatDateFilter() {
      if (!this.examDate) return;
      const date = new Date(this.examDate);
      const year = date.getFullYear();
      const month = (`0${date.getMonth() + 1}`).slice(-2); // เติม 0
      const day = (`0${date.getDate()}`).slice(-2);
      this.search_data.exam_date = `${year}-${month}-${day}`;
    },
    async createExaminerReamrk(data) {
      const res = await ExaminerRemarkService.createExaminerRemark({
        examiner_id: data.examiner_id,
        proctor_id: data.proctor_id,
        remark: data.remark,
      });
      return res.data.id;
    },
    async updateExaminer(id, data) {
      const res = await ExaminerService.updateExaminer(id, {
        proctor_id: data.proctor_id,
      });
      return res.data;
    },
    async saveInstructor() {
      if (this.second_proctor.new_second_proctor_id != this.second_proctor.second_instructor_id) {
        if (this.second_proctor.remark == "" || this.second_proctor.remark == null) {
          alert("กรุณากรอก remark");
          return;
        } else {
          var examiner = {
            examiner_id: this.second_proctor.examiner_id,
            proctor_id: this.second_proctor_id,
            remark: this.second_proctor.remark
          }
          await this.createExaminerReamrk(examiner)
          await this.updateExaminer(this.second_proctor.examiner_id, { proctor_id: this.second_proctor.new_second_proctor_id })
          document.getElementById("closed").click();
          this.GeneratePDF({year:this.second_proctor.year,term:this.second_proctor.term,exam_type:this.second_proctor.exam_type})
        this.getExaminationScheduleAll();
        }
      } else {
        document.getElementById("closed").click();
        this.getExaminationScheduleAll();
      }
    },
    async editInstructor(s) {
      console.log(s);
      this.second_proctor = s
      this.second_proctor_id = s.proctor_id
      this.second_proctor.new_second_proctor_id = s.proctor_id
      this.getProctor()

    },
    clear() {
      this.search_data = { year: '', term: '', exam_type: '', exam_date: '', faculty_id: '', course_id: '', subject: '', instructor: '' }
      this.getCourses()
      this.getAssignsDisplay(this.search_data);
    },
    toggleGroup(index) {
      const group = this.AssignsDisplay[index];
      if (group.show === undefined) {
        this.$set(group, 'show', true);  // หรือ false ถ้าต้องการค่าเริ่มต้น
      } else {
        group.show = !group.show;
      }
    },
    search() {
      this.getAssignsDisplay(this.search_data);
    },
    async deleteExamRemark() {
      try {
        const res = await ExamRemarkService.deleteExamRemark(
          {
            year: this.filter.year,
            term: this.filter.term,
            exam_type: this.filter.exam_type
          }
        );
        console.log("👥 Delete success:", res.data);
      } catch (error) {
        console.error("❌ Error assigning proctor:", error);
        throw error; // ให้ save() รู้ว่ามี error
      }
    },
    async AssignProctor() {
      try {
        const res = await ExaminationScheduleService.AssignProctor(
          this.filter.year,
          this.filter.term,
          this.filter.exam_type
        );
        this.GeneratePDF(this.filter)
        console.log("👥 Assign result:", res.data);
      } catch (error) {
        console.error("❌ Error assigning proctor:", error);
        throw error; // ให้ save() รู้ว่ามี error
      }
    },
    async GeneratePDF(filter) {
      try {
        const res = await ExaminationScheduleService.GeneratePDF(
          filter.year,
          filter.term,
          filter.exam_type
        );
        console.log("👥 GeneratePDF result:", res.data);
      } catch (error) {
        console.error("❌ Error assigning proctor:", error);
        throw error; // ให้ save() รู้ว่ามี error
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    trimSecondsFromTimeRange(timeRange) {
      return timeRange
        .split("-")
        .map(t => t.replace(/:00$/, "")) // ตัด :00 ท้าย
        .join("-");
    },

    getCourses() {
      CourseService.getCourses().then((res) => {
        this.course = res.data;
        // console.log(this.course);
      });
    },
    getMajors() {
      MajorService.getMajors().then((res) => {
        this.major = res.data;
        // console.log(this.major);
      });
    },
    getProctor() {
      ProctorService.getProctors(this.second_proctor).then((res) => {
        this.proctor = res.data;
        // console.log(this.proctor);
      });
    },
    getAcademicPosition() {
      AcademicPositionService.getAcademicPosition().then((res) => {
        this.academic_positions = res.data;
        console.log(this.academic_positions);
      });
    },
    converttime(value) {
      // ถ้าไม่ตรงใน map แปลงเป็น HH:mm
      if (typeof value === "number" && value >= 0 && value < 1440) {
        const hours = Math.floor(value / 60);
        const minutes = value % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      }

      return "ไม่พบเวลา";
    },
    generate(group){
      this.filter.year = group.year
          this.filter.term = group.term
          this.filter.exam_type = group.exam_type
this.save()
    },
    async save() {
      if (this.filter.year == "" || this.filter.term == "" || this.filter.exam_type == "") {
        alert("กรุณาเลือกปีการศึกษา, เทอม และประเภทการสอบก่อนนำเข้าข้อมูล");
        return;
      } else {
        await this.AssignProctor()
        await this.getExaminationScheduleAll();
      }
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}

.card {
  margin: 0 auto;
  /* Added */
  float: none;
  /* Added */
  margin-bottom: 10px;
  /* Added */
}

body {
  background-color: gray;
}

.row {
  margin-left: 0px;
  margin-right: 0px;
}
</style>
